import { render, staticRenderFns } from "./DocumentLoyalty.vue?vue&type=template&id=3369e064&"
import script from "./DocumentLoyalty.vue?vue&type=script&lang=js&"
export * from "./DocumentLoyalty.vue?vue&type=script&lang=js&"
import style0 from "./DocumentLoyalty.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports